
import SideBar from "./sideBar.components";
import Tools from "./Tools";
const Component = {
    ...Tools,
    SideBar,
};
export default Component;